import { History } from 'history'
import { getSpaHistoryStackLength } from 'routerHistory'

/**
 * call `history.goBack()` if history stack is not empty under current SPA runtime, aka has gone to some pages within this webapp tab
 * otherwise call `history.replace()` with `path` and `state` as fallback to prevent exiting this webapp
 *
 */
const historyBackOrReplace = (history: History, path: string, state?: unknown) => {
  if (getSpaHistoryStackLength() > 0) {
    history.goBack()
  } else {
    history.replace(path, state)
  }
}

export default historyBackOrReplace
